import claimService from '../services/claim.service';

const claims = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, claim) {
            return claimService.create(claim);
        },

        generateClaimBatch(_, params) {
            return claimService.generateClaimBatch(params.id, params.body);
        },
        addNote(_, params) {
            return claimService.addNote(params.claimId, params.text);
        },
        //READ
        get(_, params) {
            return claimService.get(params.id, params.urlParameters, params.requestId);
        },
        getClaimPreSubmissionFormDto(_, params) {
            return claimService.getClaimPreSubmissionFormDto(params.id, params.urlParameters, params.requestId);
        },        
        getreducedview(_, params) {
            return claimService.getreducedview(params.id, params.urlParameters, params.requestId);
        },
        getNonValidated(_, params) {
            return claimService.getNonValidated(params.id, params.urlParameters, params.requestId);
        },
        getageing(_, params) {
            return claimService.getAgeing(params.urlParameters);
        },
        getageingmanagement(_, params) {
            return claimService.getageingmanagement(params.urlParameters);
        },
        getPreSubmissionClaims() {
            return claimService.getPreSubmissionClaims();
        },
        getclaimsubmissionmanagementwidgetdto(_, params) {
            return claimService.getclaimsubmissionmanagementwidgetdto(params.urlParameters);
        },
        getclaimpaymentmanagementwidgetdto(_, params) {
            return claimService.getclaimpaymentmanagementwidgetdto(params.urlParameters);
        },
        getclaimpostsubmissionformdto(_, params) {
            return claimService.getclaimpostsubmissionformdto(params.id, params.requestId, params.urlParameters);
        },
        getStatuses() {
            return claimService.getStatuses();
        },
        //UPDATE
        update(_, claim) {
            return claimService.update(claim);
        },

        setPrintedVerified(_, claim) {
            return claimService.setPrintedVerified(claim.id, claim.printedVerified);
        },

        updateClaimPostSubmissionDetails(_, params) {
            return claimService.updateClaimPostSubmissionDetails(params.id, params.formData);
        },
        claimlinknumberstatusimport(_, form) {
            return claimService.claimlinknumberstatusimport(form);
        },
        //DELETE
        delete(_, id) {
            return claimService.delete(id);
        },

        //CLAIM FILES
        //CREATE
        createFile(_, params) {
            return claimService.createFile(params.claimId, params.formdata);
        },
        //READ
        getClaimFiles(_, claimId) {
            return claimService.getClaimFiles(claimId);
        },
        getFileTypes() {
            return claimService.getFileTypes();
        },
        //UPDATE
        updateFile(_, entity) {
            return claimService.updateFile(entity);
        },
        //DELETE
        deleteFile(_, params) {
            return claimService.deleteFile(params.claimId, params.claimFileId);
        }
    },
    getters: {},
    mutations: {},
};

export default claims;
